import React from 'react';

const OrganizationChartPage = React.lazy(() => import('pages/OrganizationChart/OrganizationChartPage'));

const organizationChartRoute = [
  {
    path: '/organization-chart',
    exact: true,
    name: 'Sơ đồ tổ chức tập đoàn',
    function: 'AM_COMPANY_VIEW',
    component: OrganizationChartPage,
  },
];

export default organizationChartRoute;
